// extracted by mini-css-extract-plugin
module.exports = {"FeedBack":"FeedBack_FeedBack__3jqMj"};